import type { ReactElement } from "react";

import { SWReactCountryIcons } from "@similarweb/icons";
import { Combobox } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { numberFilter } from "app/filters/numberFilter";
import { getCountryOptionPadding } from "app/pages/sales-intelligence/common-components/dropdown/LocationDropdown/rowIndent";
import type { ContactsCountry } from "app/pages/sales-intelligence/modules/company-analysis/types/contacts";

export type EmployeeLocationCountryOptionProps = {
    country: ContactsCountry;
    isSelected: boolean;
    dataAutomation: string;
    onSelect: () => void;
    optionId: string;
    depth?: number;
};

export const EmployeeLocationCountryOption = ({
    country,
    isSelected,
    dataAutomation,
    onSelect,
    optionId,
    depth = 1,
}: EmployeeLocationCountryOptionProps): ReactElement => (
    <Combobox.Option
        id={optionId}
        textValue={country.text}
        onClick={onSelect}
        data-automation={dataAutomation}
    >
        <Flex
            alignItems="center"
            justifyContent="space-between"
            gap="8px"
            width="100%"
            padding={getCountryOptionPadding(depth)}
        >
            <Flex
                alignItems="center"
                gap="8px"
                flex="1"
                minWidth={0}
            >
                <SWReactCountryIcons
                    countryCode={country.id}
                    size="xs"
                />
                <Combobox.OptionLabel>{country.text}</Combobox.OptionLabel>
            </Flex>
            <Flex
                alignItems="center"
                gap="8px"
                flexShrink={0}
            >
                <Combobox.OptionLabel>{numberFilter()(country.contactsCount)}</Combobox.OptionLabel>
                <Combobox.OptionCheckbox isChecked={isSelected} />
            </Flex>
        </Flex>
    </Combobox.Option>
);
